import { useContext, ReactNode } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { EUserRole } from '../../types/enums';

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles: EUserRole[];
  fallback?: ReactNode;
}

export function RoleGuard({ children, allowedRoles, fallback = null }: RoleGuardProps) {
  const { authInfo } = useContext(AuthContext);

  if (!authInfo?.role || !allowedRoles.includes(authInfo.role)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}